import './exportable_chart.js.coffee';# Added by Script 
Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.PostSocialView extends Monitoring.Reports.Campaign.ExportableChart

  className: 'post-social'

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.addClass('processing')

    params = {
      account_id: @options.account_id,
      content_id: @options.post.content_id,
      fb_content_id: @options.post.full_content?.data?.fb_id,
      user: @options.post.user
      date_from: @options.date_from_ISO,
      date_to: @options.date_to_ISO,
      exclude_page_owner_generated: true
    }

    $.post('/monitoring/reports/campaign/' + @options.post.type + '_social', params, @_renderChart)

  _renderChart: (data) =>
    @$el.removeClass('processing')

    interactions = for name, value of data
      {name: name, y: value}

    @series = [
      {
        name: 'Interactions'
        data: interactions
      }
    ]

    @$el.highcharts({
      chart:
        type: 'pie'
        backgroundColor: "#FFFFFF"
        height: 400
        style: {fontFamily: "Roboto", "Helvetica Neue", "Helvetica", "Arial", "sans-serif"}
      title: null
      plotOptions:
        pie:
          dataLabels:
            enabled: false
          showInLegend: true
          borderColor: null
      legend:
        align: 'center'
        layout: 'vertical'
        verticalAlign: 'bottom'
        floating: false
      exporting:
        chartOptions:
          title: null 
      series: @series
    })
    
    @trigger('rendered')